import ConvertToLTR from './types';

const convertToLTR: ConvertToLTR = (text) => text;

export default convertToLTR;
